// src/hooks/useBranding.js
import { getCurrentBranding } from '../config/branding';

export const useBranding = () => {
    try {
        return getCurrentBranding();
    } catch (error) {
        console.error('Branding configuration error:', error.message);
        throw error;
    }
};

// Hook for specific branding values
export const useBrandingValue = (path) => {
    const branding = useBranding();

    // Helper to get nested values like 'theme.primaryColor'
    const getValue = (obj, path) => {
        return path.split('.').reduce((current, key) => current?.[key], obj);
    };

    return getValue(branding, path);
};
